import React from 'react';
import PropTypes from 'prop-types';
import CopyrightWeatherby from '../../shared/copyright/CopyrightWeatherby';

const StallionBookPdf = ({
                             data: {
                                 data,
                             },
                             isMobile,
                         }) => {
    if (!data) {
        return (
            <section
                className="hp-bestProgeny__container--text-center"
            >
                No Stallion Book PDF information for this sire is available
            </section>
        );
    }

    const displayPdf = pdf =>
        (<div
            key={pdf.sequence}
            className="hp-stallionBookPdf__wrapper"
        >
            <iframe
                scrolling="auto"
                src={pdf.url}
                width="100%"
                height="600px"
            />
            {
                isMobile && (
                    <a
                        href={pdf.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            window.open(
                                pdf.url,
                                'popup',
                                'width=750px,height=600'
                            );
                            return false;
                        }}
                        className="hp-stallionBookPdf__full-screen-btn"
                    >OPEN PDF IN FULL SCREEN</a>
                )
            }
        </div>);

    return (
        <div>
            {
                data.map(pdf => displayPdf(pdf))
            }

            <CopyrightWeatherby />
        </div>
    );
};

StallionBookPdf.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.array,
    }),
    isMobile: PropTypes.bool,
};

export default StallionBookPdf;



// WEBPACK FOOTER //
// ./src/js/horse/stallionBookPdf/StallionBookPdf.jsx